// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1527":"b96f1247","4282":"c5f2453c","6809":"c5f2453c"}[chunkId] + ".chunk.css";
};